/**
 * Morgengold Landing Page JavaScript
 * - Gallery thumb switching
 * - Variant selection + price display
 * - Quantity control
 * - Add to cart via Shopify AJAX API
 * - Konzept scroll animations
 */
(function () {
  'use strict';

  // ==========================================================================
  // 1. Gallery thumbnails
  // ==========================================================================
  const mainImg = document.getElementById('mainImg');
  if (mainImg) {
    mainImg.style.transition = 'opacity .2s ease';
    document.querySelectorAll('#thumbs .t').forEach((t) => {
      t.addEventListener('click', () => {
        const src = t.dataset.src;
        if (!src) return;
        document.querySelectorAll('#thumbs .t').forEach((x) => x.classList.remove('active'));
        t.classList.add('active');
        mainImg.style.opacity = '0';
        setTimeout(() => {
          mainImg.src = src;
          mainImg.style.opacity = '1';
        }, 160);
      });
    });
  }

  // ==========================================================================
  // 2. Variant selection + cart state
  // ==========================================================================
  const variantsEl = document.getElementById('mg-variants');
  const qnEl = document.getElementById('qn');
  const totalEl = document.getElementById('mg-total');
  const addBtn = document.getElementById('addcart');

  const moneyFmt = (cents) => {
    const amount = cents / 100;
    if (amount === Math.floor(amount)) return 'CHF ' + amount + ',–';
    return 'CHF ' + amount.toFixed(2).replace('.', ',');
  };

  let state = { variantId: null, price: 0, qn: 1 };

  function readInitialVariant() {
    const active = variantsEl ? variantsEl.querySelector('.variant.active') : null;
    if (active) {
      state.variantId = active.dataset.variantId;
      state.price = parseInt(active.dataset.price, 10) || 0;
    }
  }

  function updateTotal() {
    if (totalEl) totalEl.textContent = moneyFmt(state.price * state.qn);
    if (qnEl) qnEl.textContent = state.qn;
  }

  if (variantsEl) {
    readInitialVariant();
    variantsEl.querySelectorAll('.variant').forEach((v) => {
      v.addEventListener('click', () => {
        variantsEl.querySelectorAll('.variant').forEach((x) => x.classList.remove('active'));
        v.classList.add('active');
        state.variantId = v.dataset.variantId;
        state.price = parseInt(v.dataset.price, 10) || 0;
        updateTotal();
      });
    });
  }

  // ==========================================================================
  // 3. Quantity controls
  // ==========================================================================
  const incBtn = document.getElementById('inc');
  const decBtn = document.getElementById('dec');
  if (incBtn) incBtn.addEventListener('click', () => { state.qn = Math.min(9, state.qn + 1); updateTotal(); });
  if (decBtn) decBtn.addEventListener('click', () => { state.qn = Math.max(1, state.qn - 1); updateTotal(); });
  updateTotal();

  // ==========================================================================
  // 4. Add to cart — Shopify AJAX
  // ==========================================================================
  async function addToCart(variantId, quantity) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({ description: 'Unbekannter Fehler' }));
      throw new Error(err.description || 'Cart add failed');
    }
    return res.json();
  }

  async function refreshCartCount() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      const pills = document.querySelectorAll('.cart-pill');
      pills.forEach((p) => { p.textContent = 'Warenkorb · ' + cart.item_count; });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } catch (_) { /* ignore */ }
  }

  function flashButton(btn, text, bg) {
    const orig = btn.innerHTML;
    const origBg = btn.style.background;
    btn.innerHTML = text;
    btn.style.background = bg;
    btn.disabled = true;
    setTimeout(() => { btn.innerHTML = orig; btn.style.background = origBg; btn.disabled = false; }, 1800);
  }

  if (addBtn) {
    addBtn.addEventListener('click', async () => {
      if (!state.variantId) {
        flashButton(addBtn, '⚠ Variante wählen', 'oklch(0.65 0.18 30)');
        return;
      }
      addBtn.disabled = true;
      const originalContent = addBtn.innerHTML;
      addBtn.innerHTML = 'Wird hinzugefügt ...';
      try {
        await addToCart(state.variantId, state.qn);
        addBtn.innerHTML = '✓ Zum Warenkorb hinzugefügt';
        addBtn.style.background = 'oklch(0.55 0.12 150)';
        refreshCartCount();
        setTimeout(() => {
          addBtn.innerHTML = originalContent;
          addBtn.style.background = '';
          addBtn.disabled = false;
          updateTotal();
        }, 1600);
      } catch (e) {
        console.error('Morgengold cart error', e);
        addBtn.innerHTML = '⚠ ' + (e.message || 'Fehler');
        addBtn.style.background = 'oklch(0.65 0.18 30)';
        setTimeout(() => {
          addBtn.innerHTML = originalContent;
          addBtn.style.background = '';
          addBtn.disabled = false;
        }, 2400);
      }
    });
  }

  // Hero bundle primary action: for now just scroll to product
  document.querySelectorAll('[data-mg-action="hero-bundle"]').forEach((b) => {
    b.addEventListener('click', (ev) => {
      ev.preventDefault();
      const target = document.getElementById('produkt');
      if (target) target.scrollIntoView({ behavior: 'smooth' });
    });
  });

  // ==========================================================================
  // 5. Konzept scroll animations (reveal-on-scroll + rail progress)
  // ==========================================================================
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add('in'); });
  }, { threshold: 0.25 });
  document.querySelectorAll('.konzept .kz-card, .konzept .kz-graphic').forEach((el) => io.observe(el));

  document.querySelectorAll('.konzept .kz-h').forEach((h) => {
    if (h.dataset.split === '1') return;
    const text = h.textContent.trim();
    h.innerHTML = text.split(' ').map((w, i) => `<span class="w" style="--i:${i}">${w}</span>`).join(' ');
    h.dataset.split = '1';
  });

  const sec = document.getElementById('konzept');
  if (sec) {
    const stage = sec.querySelector('.kz-stage');
    let rafId = null;
    const tick = () => {
      rafId = null;
      const r = sec.getBoundingClientRect();
      const vh = window.innerHeight || 1;
      const total = r.height + vh;
      const passed = Math.min(total, Math.max(0, vh - r.top));
      const pct = Math.max(0, Math.min(100, (passed / total) * 100));
      if (stage) stage.style.setProperty('--rail-progress', pct + '%');
      // Parallax bewusst entfernt — verursachte Jitter auf Stage 3 wegen der
      // vielen Sub-Animationen (kz-mol, kz-organ, kz-ray). Die internen SVG
      // Animationen reichen visuell aus.
    };
    const onScroll = () => { if (!rafId) rafId = requestAnimationFrame(tick); };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    tick();
  }
})();
